var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimelineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Timeline"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 1371",
    x1: 0.55,
    x2: 0.55,
    y2: 14.6667,
    stroke: "#0B1B4E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 1372",
    x1: 14.668,
    y1: 14.3,
    x2: 0.00130267,
    y2: 14.3,
    stroke: "#0B1B4E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1373",
    d: "M7.33203 4.58398L2.7487 4.58398",
    stroke: "#0B1B4E",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1375",
    d: "M10.082 10.084H6.41536",
    stroke: "#0B1B4E",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1374",
    d: "M11.918 7.33398L4.58464 7.33398",
    stroke: "#0B1B4E",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineIcon);
export default __webpack_public_path__ + "static/media/Timeline-icon.237f3ee797a7e40f88a407c910fad8d2.svg";
export { ForwardRef as ReactComponent };